import { get } from 'lodash';
import React, { Component, PropTypes } from 'react';
import ComponentTitle from './ComponentTitle';
import classNames from 'classnames';
import { checkIOSDevice } from '../../utils/DOMUtils';
import { setMetaTags } from 'lib/frankly';
import Timestamp from 'components/Timestamp';
import { BREAKPOINTS } from '../../constants/FRNBaseStyles';
import { getCurrentWindowBreakpointSize } from '../../utils/WindowUtils';
import { getCanonicalLink } from  'utils/SeoUtils';

const ADDTHIS_POSITION = {
  BELOW_BODY: 'below-body',
  ABOVE_BODY: 'above-body'
};

class Link extends Component {
  static propTypes = {
    showTitle: PropTypes.bool,
    showTimestamp: PropTypes.bool,
    showAbstract: PropTypes.bool,
    addMetaTags: PropTypes.bool,
    iframeHeight: PropTypes.object,
    FRN_rawResponses: PropTypes.array,
    addThisOptions: PropTypes.shape({
      className: PropTypes.string,
      position: PropTypes.oneOf([ADDTHIS_POSITION.BELOW_BODY, ADDTHIS_POSITION.ABOVE_BODY])
    }),
  }

  static defaultProps = {
    showTitle: true,
    showTimestamp: false,
    showAbstract: false,
    addMetaTags: true,
    iframeHeight: {
      xs: {
        height: 1000
      },
      sm: {
        height: 1000
      },
      md: {
        height: 1000
      },
      lg: {
        height: 1000
      },
      xl: {
        height: 1000
      }
    }
  }

  state = {
    width: null,
    hieght: null
  }

  componentDidMount() {
    this._updateIFrameDimensions();

    window.addEventListener('resize', () => this._updateIFrameDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this._updateIFrameDimensions());
  }

  _updateIFrameDimensions() {
    const { iframeHeight } = this.props;
    const currentWindowBreakpointSize = getCurrentWindowBreakpointSize();
    let height;
    let width;

    if (iframeHeight[currentWindowBreakpointSize]) {
      width = iframeHeight[currentWindowBreakpointSize].width;
      height = iframeHeight[currentWindowBreakpointSize].height;
    }

    this.setState({
      width,
      height
    });
  }

  render() {
    if (!this.props.FRN_rawResponses) {
      return null;
    }

    const {
      showTitle,
      showTimestamp,
      showAbstract,
      addMetaTags,
      FRN_rawResponses: [
        {
          data: {
            url = '',
            link = '',
            datetime: {
              created = ''
            } = {},
            seo: {
              robot = '',
              keywords = '',
              description = '',
            } = {},
            images: {
              graphic: {
                filename: imageIFrame
              } = {}
            } = {},
            iframe: {
              bordercolor = '',
              showborder = false,
              showscrollbar = false,
              height: heightFromFeed = ''
            } = {},
            abridged: {
              headline = '',
              abstract = '',
              abstractimage: {
                filename: heroImageFilename = ''
              } = {}
            } = {}
          } = {}
        } = {}
      ] = [],
      addThisOptions: {
        className: addThisClassName = '',
        position = ADDTHIS_POSITION.ABOVE_BODY
      } = {},
    } = this.props;

    if (addMetaTags) {
      setMetaTags(this, [{
        name: 'description',
        content: description
      }, {
        name: 'keywords',
        content: keywords
      }, {
        name: 'robots',
        content: robot
      }, {
        rel: 'canonical',
        href: getCanonicalLink(get(this, 'props.FRN_rawResponses[0].data', {})),
        isLink: true
      }, {
        property: 'og:title',
        content: headline
      }, {
        property: 'og:type',
        content: 'article'
      }, {
        property: 'og:url',
        content: link
      }, {
        property: 'og:image',
        content: heroImageFilename
      }, {
        property: 'og:description',
        content: description
      }, {
        name: 'twitter:card',
        content: 'summary_large_image'
      }, {
        name: 'twitter:description',
        content: description
      }, {
        name: 'twitter:title',
        content: headline
      }, {
        name: 'twitter:image',
        content: heroImageFilename
      }]);
    }

    const { width, height } = this.state;
    // heightFromFeed just is used for MD - LG - XL breakpoints
    const hasIFrameHeight = heightFromFeed && (window.innerWidth >= BREAKPOINTS[2]["minWidth"]);
    const iframeStyles = {
      width: width ? `${width}px` : null,
      height: hasIFrameHeight ? `${heightFromFeed}px` : `${height}px`
    };

    /**
     * Because the iframe isn't responsive in ios browsers
     * issue https://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari#answer-23083463
     */
    const isIOSDevice = checkIOSDevice();
    const border = showborder && '1px solid ' + bordercolor;
    const addThisContent = <div className={ addThisClassName }/>;
    const hasAboveAddThis = position === ADDTHIS_POSITION.ABOVE_BODY;
    const iframeClassName = classNames('embed-responsive-item', 'Link-item', { 'Link-item--iOS': isIOSDevice });
    let scrolling = showscrollbar ? 'yes' : 'no';

    if (isIOSDevice && scrolling === 'yes') {
      iframeStyles['overflow'] = 'auto';
      iframeStyles['-webkit-overflow-scrolling'] = 'touch';  

      scrolling = 'no';
    }

    return (
      <div className='Link'>
        { hasAboveAddThis && addThisContent }
        <div>
          { showTitle && <ComponentTitle showArrow={ false } title={ headline } /> }
          { showAbstract && <div className='Link-abstract' dangerouslySetInnerHTML={{ __html: abstract }} ></div> }
        </div>
        { showTimestamp && <Timestamp publishDate={ created }/> }
        <div className={`embed-responsive ${!height ? 'embed-responsive-16by9' : ''}`} style={ iframeStyles }>
          <iframe className={ iframeClassName }
            style={{ border }}
            src={ url || imageIFrame }
            scrolling = { scrolling }
          />
        </div>
        { !hasAboveAddThis && addThisContent }
      </div>
    );
  }
}

export default Link;



// WEBPACK FOOTER //
// ./app/components/shared/Link.js